import { useIsFetching, useIsMutating, useQueryClient } from 'react-query';
import type { Query } from 'react-query/types/core/query';

const NON_BLOCKING_QUERY_KEYS = new Set(['dsm', 'dsm-terrain-base']);

const isNonBlockingWarmDsmFetch = (query: Query): boolean => {
	const rootKey = Array.isArray(query.queryKey) ? query.queryKey[0] : query.queryKey;
	return typeof rootKey === 'string'
		&& NON_BLOCKING_QUERY_KEYS.has(rootKey)
		&& query.getObserversCount() === 0;
};

const useQueriesRunningInBackGround = (keys: string[] = [], type: 'mutating' | 'fetching'= 'fetching') => {
	const queryClient = useQueryClient();
	const isFetching = !!useIsFetching({
		fetching: true,
		predicate: (query) => !isNonBlockingWarmDsmFetch(query),
	});
	const isMutating = !!useIsMutating({ fetching: true });

	if (type === 'fetching' && keys.length){
		return (keys.some(queryKey => !!queryClient.isFetching({ queryKey })));
	}
	if (type === 'mutating' && keys.length)
		return (keys.some(mutationKey => !!queryClient.isMutating({ mutationKey, exact: true, fetching: true })));

	return isFetching || isMutating;
};

export default useQueriesRunningInBackGround;
